(() => {
  const dose = 18;
  const sizes = [500, 1000, 2000];
  const days = (grams, cups) => grams / (dose * cups);
  const label = grams => grams === 500 ? '500g' : `${grams / 1000}kg`;
  const interval = frequency => frequency === 'fortnightly' ? 14 : 30;
  const recommend = (cups, frequency) => sizes.reduce((best, size) =>
    Math.abs(days(size, cups) - interval(frequency)) < Math.abs(days(best, cups) - interval(frequency)) ? size : best, sizes[0]);
  const coverage = (size, cups, frequency) => {
    const duration = days(size, cups);
    const rounded = Math.round(duration * 10) / 10;
    const schedule = frequency === 'fortnightly' ? 14 : 31;
    const gap = Math.max(0, Math.round((schedule - duration) * 10) / 10);
    const timing = frequency === 'fortnightly' ? 'Deliveries are 14 days apart.' : 'Monthly deliveries are 28-31 days apart.';
    const caveat = gap ? ` That is about ${gap} ${gap === 1 ? 'day' : 'days'} short of ${schedule} days, so allow for a top-up.` : ' This covers the interval at that dose.';
    return `${label(size)} lasts about ${rounded} days at ${cups} ${cups === 1 ? 'cup' : 'cups'} a day. ${timing}${caveat}`;
  };
  window.TempoGuide = {dose, days, label, recommend, coverage};
})();
